import React from 'react';
import CreateAppraisal from '../../modules/CreateProposal';
// import CreateAppraisal from 'app/modules/Appraisals/CreateAppraisal';

const CreateProposal = () => (
  <CreateAppraisal />
);

export default CreateProposal;
